import React from 'react';
import PropTypes from 'prop-types';
import authorizationShape from '../authorizationShape';
import AuthorizationHistoryLineItem from './AuthorizationHistoryLineItem';
import { formatAmount, formatDates } from '../utils';

const VoidedAuthorizationFields = ({ authorization }) => (
  <>
    <AuthorizationHistoryLineItem field="Amount Requested">
      {formatAmount(authorization)}
    </AuthorizationHistoryLineItem>
    <AuthorizationHistoryLineItem field="Date(s) Requested">
      {formatDates(authorization)}
    </AuthorizationHistoryLineItem>
    <AuthorizationHistoryLineItem field="Payer Authorization ID">
      {authorization.payer_authorization_number || 'N/A'}
    </AuthorizationHistoryLineItem>
    <AuthorizationHistoryLineItem field="Notes">
      {authorization.reviewer_note ? (
        <div className="whitespace-pre-line">{authorization.reviewer_note}</div>
      ) : (
        'N/A'
      )}
    </AuthorizationHistoryLineItem>
  </>
);

VoidedAuthorizationFields.propTypes = {
  authorization: PropTypes.shape(authorizationShape).isRequired,
};

export default VoidedAuthorizationFields;
